import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { FormField, Toolbar } from "admin-on-rest";
import { Box } from "rebass";

import getDefaultValues from "../components/form/getDefaultValues";
import { ValuesForm } from "../components";
import { DivFormContainer } from "./styled";

class PaymentModeForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      this.props.save(values, redirect);
    });

  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;

    return (
      <div>
        <form className="simple-form">
          <DivFormContainer>
            <Box px={[1, 2]}>
              {Children.map(
                children,
                input =>
                  input && (
                    <div
                      key={input.props.source}
                      className={`aor-input-${input.props.source}`}
                      style={input.props.style}
                    >
                      <FormField
                        input={input}
                        resource={resource}
                        record={record}
                        basePath={basePath}
                      />
                    </div>
                  )
              )}
            </Box>
          </DivFormContainer>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
          <ValuesForm isDebug={false} formName={"record-form"} />
        </form>
      </div>
    );
  }
}

PaymentModeForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func
};

PaymentModeForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};
//const selector = formValueSelector("record-form");
const enhance = compose(
  connect((state, props) => {
    return {
      initialValues: getDefaultValues(state, props)
    };
  }, {}),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(PaymentModeForm);



// WEBPACK FOOTER //
// ./src/paymentmode/PaymentModeForm.js